import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import type { BaseService } from '@essent/common';
import { API_PUBLIC_PREFIX } from '@core/config-angular';
import type { Observable } from 'rxjs';
import { type PostFormSubmitBody } from '@innogy/feh/models';

@Injectable()
export class PostGenericFormSubmitService
  implements BaseService<PostFormSubmitBody, void>
{
  private readonly apiUrl: string | null = inject(API_PUBLIC_PREFIX, {
    optional: true,
  });
  private readonly httpClient = inject(HttpClient);

  //We need this to comform to the BaseService interface, yet this API is not versioned
  public readonly apiVersion = '3';
  public readonly endpoint = `${this.apiUrl || ''}/feh/generic/formsubmit/v${
    this.apiVersion
  }`;

  public call$(payload: PostFormSubmitBody): Observable<void> {
    return this.httpClient.post<void>(this.endpoint, payload);
  }
}
